module.exports = __webpack_public_path__ + "img/default.7060840f.svg";